export const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

/**
 * Whether the current time falls within the eSIM redemption window:
 * from 7 days before departure until the trip end date.
 * If no end date is available, assumes the trip hasn't ended once departure has passed.
 */
export function isWithinEsimRedemptionWindow(
  departureDate: Date | string | undefined,
  endDate?: Date | string,
): boolean {
  if (!departureDate) return false
  const departure = new Date(departureDate).getTime()
  const now = Date.now()
  if (departure - now > SEVEN_DAYS_MS) return false
  if (!endDate) return true
  return new Date(endDate).getTime() >= now
}
